<div class="container-dash">
  <div class="row-dash">
      <app-dashboard-navbar></app-dashboard-navbar>
      <div class="main">
        <header>
            <div class="card">
                <div class="card-header">
                  Publicar en Twitter
                </div>
                <div *ngIf="twitterLogged" class="card-body">
                  <form class="form-post-twitter" [formGroup]="postTwitterForm" (ngSubmit)="submitPostTwitter($event)">
                    <div class="row">
                    <div class="form-group">
                      <label for="inputMessage">Texto</label>
                      <textarea id="inputMessage" class="form-control" cols="80" rows="4" placeholder="Insert your post" formControlName="message" autofocus></textarea>
                    </div>
                    <div class="form-group">
                      <label for="inputPhotoURL">Cargar imagen</label>
                      <input type="file" id="inputFile" class="form-control imagen" placeholder="URL de la foto" formControlName="photo_url">
                    </div>
                  </div>
                    <div *ngIf="postError" class="alert alert-danger" role="alert"> 
                      Error al intentar publicar el tweet
                    </div>
                    <div *ngIf="postOk" class="alert alert-success" role="alert"> 
                      Tweet publicado correctamente
                    </div>
                    <br />
                    <button type="submit" class="btn btn-outline-success my-2 my-sm-0">Publicar</button>
                  </form>
                </div>
                <div *ngIf="!twitterLogged" class="card-body">
                    <div class="alert alert-danger" role="alert"> 
                      Para poder twittear necesitas tener una cuenta de Twitter vinculada
                    </div>
                </div>
              </div>
        </header>
      </div>
  </div>
</div>

<app-footer></app-footer>